import React, {useMemo} from 'react';
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {useSelector} from "react-redux";
import {EllipsisText, FlexColumnSection, FlexRowSection} from "../../../styles/globalStyles";
import {
    getAttendanceDisplay,
    getMembershipAddons,
    getMembershipPriceText,
    isLocationIL,
    sortCourseEventDays
} from "../../../helpers/functions";
import dayjs from "dayjs";
import {t} from "i18next";
import UserAvatar from "../../../components/UserAvatar";
import {DB_DATE_FORMAT} from "@arboxappv4/shared/src/constants/constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {getDisabledPagesCourseProps} from "@arboxappv4/shared/src/helpers/DisablePages";

const CourseInfo = (props) => {
    const { course } = props;
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const box = useSelector(state => state.site.box)
    const {isMobile} = useScreenSize()
    const displayProps = useMemo(() => course ? getDisabledPagesCourseProps(course) : {}, [course])
    const attendanceDisplay = useMemo(() => getAttendanceDisplay(displayProps, course), [displayProps, course])
    const currencySymbol = useMemo(() => globalLocation?.currency_symbol, [globalLocation]);
    const courseMT = useMemo(() => course?.membership_types?.find(mt => mt.type === 'regular' || mt.type === 'recurring'), [course])

    if(!course || !globalLocation) return <></>

    return (
        <FlexColumnSection gap={isMobile ? '10px' : '15px'} flex={'unset'}>
            <span>
                {getMembershipPriceText(courseMT, currencySymbol)} {course.partialBookingOptions?.length ? t(`for-hug-${courseMT.type}`) : ''}
                {course?.partialBookingOptions && course.partialBookingOptions.map(option => <div>{t(`${option.numOfDays}-numOfDays`, {price: option.price, currencySymbol})}</div>) }
                {(isLocationIL() && courseMT.max_installments > 1 && courseMT.price > 0) && <span> ({t('up-to-installments', {num: courseMT.max_installments})}) </span>}
                {courseMT.addons?.length > 0 && <div>{getMembershipAddons(courseMT.addons, currencySymbol)}</div>}
            </span>
            <FlexRowSection gap={'10px'}>
                <div>
                    {course.start_date === course.end_date ? t('one-day-hug', {start: dayjs(course.start_date, DB_DATE_FORMAT).format(globalLocation.date_format), interpolation: {'escapeValue': false}})
                    :
                    `${dayjs(course.start_date, DB_DATE_FORMAT).format(globalLocation.date_format)} - ${course.end_date ? dayjs(course.end_date, DB_DATE_FORMAT).format(globalLocation.date_format) : t('unlimited')}`}
                </div>
            </FlexRowSection>
            {displayProps.showNumRemainingSlots && course.end_date && <div>{t('remaining-slots', {remainingSlots: course.remainingSlots})}</div>}
            {course.coach && displayProps.showCoach && <UserAvatar user={course.coach} nameType={'full'}/>}
            {course.second_coach && displayProps.showCoach && <UserAvatar user={course.second_coach} nameType={'full'}/>}
            {(displayProps.showNumRegistered || displayProps.showNumOpenSpots) && <EllipsisText isMobile={isMobile} width={'250px'}>
                <FlexRowSection gap={'8px'}>
                    <FontAwesomeIcon icon={solid('user')} color={Colors.siteBlack} size={'xs'}/>
                    <span>{attendanceDisplay}</span>
                </FlexRowSection>
            </EllipsisText>}
            {box.locations_box.length > 1 && <span>{t('location')}: {course.locations_box.location}</span>}
        </FlexColumnSection>
    );
};

export default CourseInfo;